import { getInstance } from "./authWrapper";

export const authGuard = (to, from, next, scope) => {
  const authService = getInstance();

  const fn = () => {
    if (authService.isAuthenticated) {
      if (authService.scopes.includes(scope)) {
        return next();
      } else {
        return next('/unauthorized');
      }
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};
